module.exports = __webpack_public_path__ + "static/media/icono_seccionharina.b1f42aed.png";